export function getRouteConsts(routeName) {
  return routeName.replace('/', '');
}
